import { useHistory } from 'react-router-dom';
import './landingBackground.scss';
import { Logo } from '../../uiKit/assets/svg/logo';

const LandingBackground = ({ Component, color = 'whiteBackground' }) => {
    const history = useHistory();

    const onLogoClick = () => {
        history.push('/');
    }

    return (
        <div className={`landingBackground ${color}`}>
            <div className='logoWrapper' onClick={onLogoClick}>
                <Logo />
            </div>
            <div className="contentWrapper">
                {!!Component ? (<Component />) : null}
            </div>
            <div className='downWave' />
        </div>
    )
}

export default LandingBackground;